<template>
    <div>
       <div id="myChart" :style="{width: '50%', height: '600px'}"></div>
       <button @click="chart_time_btn">点击我</button>
    </div>
</template>
<style>
</style>
<script>
export default {
  // data() {
  //   return {
  //     msg: [],
  //     seriesdata:[]
  //   };
  // },
  // created() {
  //   this.msg = [5, 20, 36, 10, 10, 20];
  // },
  // mounted() {
  //   this.drawLine(); // 初始化
  //   this.init();
  // },
  // destroyed() {
  //   //关键四
  //   //移除自适应
  //   window.removeEventListener("resize", this.init, 20);
  // },
  // methods: {
  //   drawLine() {
  //     // 基于准备好的dom，初始化echarts实例
  //     let myChart = this.$echarts.init(document.getElementById("myChart"));
  //     // 绘制图表
  //     myChart.setOption({
  //       title: {
  //         text: "在Vue中使用echarts",
  //         left: "left",
  //         top: 10
  //       },
  //       tooltip: {},
  //       legend: {
  //         data: ["监测点", "设站点", "测站点"]
  //       },
  //       xAxis: {},
  //       yAxis: {},
  //       series: [
  //         {
  //           name: "监测点",
  //           type: "line",
  //           data: [[2, 20], [8, 12]],
  //           symbol: "triangle",
  //           lineStyle: {
  //             normal: {
  //               color: "green",
  //               width: 2
  //             }
  //           },
  //           itemStyle: {
  //             normal: {
  //               borderWidth: 3,
  //               borderColor: "yellow",
  //               color: "blue"
  //             }
  //           }
  //         },
  //         {
  //           name: "测站点",
  //           type: "line",
  //           data: [[3, 1.5], [8, 12]],
  //           symbol: "triangle",
  //           lineStyle: {
  //             normal: {
  //               width: 2,
  //               color: "black",
  //               type: "dashed"
  //             }
  //           },
  //           itemStyle: {
  //             normal: {
  //               borderWidth: 3,
  //               borderColor: "red",
  //               color: "black"
  //             }
  //           }
  //         },
  //         {
  //           name: "设站点",
  //           type: "line",
  //           data: [[9.5, 30], [8, 12]],
  //           lineStyle: {
  //             normal: {
  //               width: 2,
  //               color: "pink"
  //             }
  //           },
  //           itemStyle: {
  //             normal: {
  //               borderWidth: 3,
  //               borderColor: "cyan",
  //               color: "pink"
  //             }
  //           }
  //         },
  //         {
  //           type: "effectScatter",
  //           coordinateSystem: "cartesian2d",
  //           data: [[9.5, 30]],
  //           symbolSize: 15,
  //           rippleEffect: {
  //             period: 3,
  //             brushType: "stroke"
  //           }
  //         }
  //       ]
  //     });
  //   },
  //   init() {
  //     //关键三
  //     // echarts自适应
  //     setTimeout(() => {
  //       window.addEventListener("resize", () => {
  //         this.myChart.resize();
  //         //   this.myPie.resize();
  //       });
  //     }, 20);
  //   }
  // }

  data() {
    return {
      dataArr: ["1月", "2月", "3月", "4月", "5月", "6月"], //需要替换的数据
      series: [
        {
          name: "销量",
          type: "line", //折线图 可以自定义bar柱状图
          data: [5, 20, 36, 10, 10, 20]
        }
      ]
    };
  },
  mounted() {
    this.drawLine();
  },
  watch: {
    dataArr(val) {
      //监听数据发生改变 刷新图表数据
      this.drawLine();
    }
  },
  methods: {
    drawLine() {
      var odataArr = this.dataArr;
      console.log(this.dataArr);
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        title: { text: "在Vue中使用echarts" },
        tooltip: {},
        xAxis: {
          data: odataArr //data: ["衬衫","羊毛衫","雪纺衫","裤子","高跟鞋","袜子"]
        },
        yAxis: {},
        series: this.series
      });
    },
    chart_time_btn() {
      //点击事件 更改图表数据
      console.log();
      this.dataArr = ["22月", "22月", "32月", "42月", "52月", "26月"];
      this.series.push({
        name: "数量",
        type: "line", //折线图 可以自定义bar柱状图
        data: [15, 2, 30, 1, 15, 20]
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/admin/testecharts.vue